import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {StyledLast30DaysSpending, StyledLast30DaysSpendingAmount, StyledLast30DaysSpendingPercentage} from './StyledLast30DaysSpending';
import {amountHelpers} from '../../../../utils/helpers';
import IncreaseLine from '../../../../static/images/pages/overview/increase-line.svg';
import DecreaseLine from '../../../../static/images/pages/overview/decrease-line.svg';

const Last30DaysSpending = ({amount, percentage, ...rest}) => {
  const [t] = useTranslation('main');

  const percent = useMemo(() => {
    if (percentage === 0) return 0;
    const value = percentage > 0 ? -percentage : Math.abs(percentage);
    return Number(value.toFixed(2));
  }, [percentage]);

  const chartLine = percent !== 0 ? percent > 0 ? IncreaseLine : DecreaseLine : null;

  return (
    <StyledLast30DaysSpending
      {...rest}
      size={9}
      direction='horizontal'
    >
      <Space direction='vertical' size={20}>
        <h5>{t(('totalSpendLast30D'))}</h5>
        <Space direction='horizontal' size='small'>
          <StyledLast30DaysSpendingAmount>
            {amountHelpers.formatCurrencyAbbreviated(amount)}
          </StyledLast30DaysSpendingAmount>
          {percentage !== 0 && (
            <StyledLast30DaysSpendingPercentage className={percent > 0 ? 'increase' : 'decrease'}>
              {percent > 0 ? '+' : ''}{percent}%
            </StyledLast30DaysSpendingPercentage>
          )}
        </Space>
      </Space>
      {chartLine && <img src={chartLine} alt='chart line' />}
    </StyledLast30DaysSpending>
  );
}

Last30DaysSpending.propTypes = {
  amount: PropTypes.number,
  percentage: PropTypes.number,
}

export default Last30DaysSpending;
